const config = {
	graphqlUrl: process.env.REACT_APP_GRAPHQL_URL,
};

export default config;
